import { organisationConstants } from '../../../_constants/organisation.constants';
import { organisationService } from '../../../_services/organisation.service';

import {getManageMetricAction} from './getManageMetricList.action';


export const updateManageMetricAction = {
    updateManageMetricHandler
};

function updateManageMetricHandler(orgId, compId, data) {
    return dispatch => {
        dispatch(request(data));
        organisationService.addManageMetricHandler(orgId, compId, data)
            .then(
                manageMetricList => {
                    dispatch(success(manageMetricList));
                    dispatch(getManageMetricAction.getManageMetricHandler(orgId, 0))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(data) { return { type: organisationConstants.REQUEST_UPDATE_MANAGE_METRIC, data } }
    function success(manageMetricList) { return { type: organisationConstants.RECEIVE_UPDATE_MANAGE_METRIC, manageMetricList } }
    function failure(error) { return { type: organisationConstants.UPDATE_MANAGE_METRIC_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/organisations/ManageMetric/updateManageMetric.action.js